export default "__VITE_ASSET__d0cc625d__"